import { useState } from "react";
import "./Auditoriums.css";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";

const auditoriumCategories = [
  {
    category: "Indoor Auditorium",
    description:
      "Fully enclosed auditoriums equipped with stage, seating, sound systems, and multimedia facilities.",
    halls: [
      {
        id: 1,
        name: "University Indoor Auditorium",
        images: [
          "/campuslife/auditorium/indoor1.JPG",
          "/campuslife/auditorium/indoor2.JPG"
        ],
        details:
          "Used for convocations, academic conferences, cultural programmes, seminars, and university-level events."
      }
    ]
  },
  {
    category: "Outdoor Auditorium (Open Air Theatre)",
    description:
      "Open-air venues designed for large gatherings, cultural festivals, youth events, and celebrations.",
    halls: [
      {
        id: 2,
        name: "Open Air Theatre",
        images: [
          "/campuslife/auditorium/outdoor1.JPG",
          "/campuslife/auditorium/outdoor2.JPG"
        ],
        details:
          "Ideal for cultural festivals, student activities, public meetings, and large audience programmes."
      }
    ]
  },
  {
    category: "Seminar Halls",
    description:
      "Academic seminar halls supporting workshops, FDPs, student presentations, and guest lectures.",
    halls: [
      
      {
        id: 4,
        name: "University Science Seminar Hall",
        images: [
          "/campuslife/auditorium/seminar1.JPG"
        ],
        details:
          "Supports academic interactions, research discussions, and departmental seminars."
      }
    ]
  }
];

const Auditoriums = () => {
  const [selectedHall, setSelectedHall] = useState(null);

  return (
    <>
      <Navbar />

      {/* ================= BANNER ================= */}
      <div className="auditorium-banner">
        <img
          src="/campuslife/auditorium/indoor1.JPG"
          alt="Auditoriums at Rayalaseema University"
        />
        <div className="auditorium-banner-overlay">
          <h1>Auditoriums & Seminar Halls</h1>
          <p>Academic, Cultural & Event Facilities</p>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <section className="auditorium-section">
        <h2 className="auditorium-title">
          Auditorium Facilities
        </h2>
        <p className="auditorium-subtitle">
          Indoor, Outdoor and Seminar Hall facilities at Rayalaseema University
        </p>

        {auditoriumCategories.map((group, index) => (
          <div key={index} className="auditorium-category">
            <h3 className="auditorium-category-title">
              {group.category}
            </h3>
            <p className="auditorium-category-desc">
              {group.description}
            </p>

            <div className="auditorium-grid">
              {group.halls.map((hall) => (
                <div
                  key={hall.id}
                  className="auditorium-card"
                  onClick={() => setSelectedHall(hall)}
                >
                  <img src={hall.images[0]} alt={hall.name} />
                  <h4>{hall.name}</h4>
                  <button className="auditorium-btn">
                    View Gallery
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}

        {/* ================= MODAL ================= */}
        {selectedHall && (
          <div className="auditorium-modal-overlay">
            <div className="auditorium-modal">
              <button
                className="auditorium-close"
                onClick={() => setSelectedHall(null)}
              >
                ✕
              </button>

              <h3>{selectedHall.name}</h3>
              <p className="auditorium-desc">
                {selectedHall.details}
              </p>

              <div className="auditorium-gallery">
                {selectedHall.images.map((img, i) => (
                  <img key={i} src={img} alt="Auditorium view" />
                ))}
              </div>
            </div>
          </div>
        )}
      </section>

      <Footer />
    </>
  );
};

export default Auditoriums;
